<template>
  <div class="mod-project mod-project-details">
    <div class="mod-project-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in switchList"
          :key="index"
          v-model="selectedTab"
          @change="changeTab(item.name)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="mod-project-base-info" v-if="selectedTab === '基本信息'">
      <ProjectBaseInfo :parentProjectBaseInfoFrom="projectBaseInfoFrom"></ProjectBaseInfo>
    </div>
    <div class="mod-project-rental-costs" v-if="selectedTab === '场租计费规则'">
      <ProjectRentalCostsInfo :parentProjectRentalCostsFrom="projectRentalCostsFrom"></ProjectRentalCostsInfo>
    </div>
    <div class="mod-project-rental-costs" v-if="selectedTab === '操作收入计费规则'">
      <ProjectOperationInfo :parentProjectOperationFrom="projecttOperationFrom"></ProjectOperationInfo>
    </div>
    <div class="mod-project-logistics" v-if="selectedTab === '物流计费规则'">
      <LogisticsPage
        :parentProjectsName="projectsName"
        :parentExpressTabs="expressTabs"
        :parentCityDeliveryUnitPrice="cityDeliveryUnitPrice"
      ></LogisticsPage>
    </div>
  </div>
</template>

<script>
import ProjectBaseInfo from '@/components/base/project/base-info.vue';
import ProjectRentalCostsInfo from '@/components/base/project/rental-costs.vue';
import ProjectOperationInfo from '@/components/base/project/operation.vue';
import LogisticsPage from '@/components/base/project/logistics.vue';
import projectManageMixins from "@/common/mixins/project-manage.js"
export default {
  mixins: [projectManageMixins],
  components: {
    ProjectBaseInfo,
    ProjectRentalCostsInfo,
    ProjectOperationInfo,
    LogisticsPage
  },

  data() {
    return {
      projectId: null
    }
  },

  watch: {
    '$route': {
      handler(v) {
        if (this.projectId !== v.query.projectId && v.name === 'project-details/:name') {
          this.projectId = v.query.projectId
          this.projectDetail()
        }
      },
      deep: true,
    }
  },

  created() {
    this.projectId = this.$route.query.projectId
    this.projectDetail()
  },

  deactivated() {
    this.projectId = null
  },

  methods: {
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/project/mod-project.scss';
</style>